import { Filing } from '../../../utilities/interfaces/Filing';
import { TaskBoardCard } from '../../../utilities/interfaces/TaskBoardCard';
import { TaskPriority } from '../../../utilities/interfaces/TaskPriority';
import { WorkflowStatuses } from '../../../utilities/enums/WorkflowStatuses';
import { WorkQueueColors } from '../../../utilities/enums/WorkQueueColors';

class CardHelper {
  // Groupings by filing.WorkflowStatusId

  // ColumnName
  //    Status (statusId)

  // New (#A4ABB6)
  //    New (standard) (1)
  //    New (emergency) (24)
  //    New (non-substantial) (25)
  // Public Hearing Pending (#06D6A0)
  //    Ready for Public Hearing (2)
  //    Public Hearing - Pending (3)
  // Attorney General's Office Pending (#ED8B84)
  //    AG - Pending (6)
  //    AG - Returned to Agency (9)
  // Governor's Office Pending (#FFB302)
  //    GPRO - Pending (standard, non-substantive) (10)
  //    GPRO - Pending (emergency) (26)
  //    GPRO - Returned to Agency (standard, non-substantive) (13)
  //    GPRO - Returned to Agency (emergency) (28)
  // Secretary of State Office Pending (#5081AB)
  //    SOS - Pending (14)
  // Ready for Promulgation (#2DCCFF)
  //    Ready for Promulgation(15)
  private getPriority(filing: Filing): TaskPriority {
    var taskPriority: TaskPriority = { color: '#118ab2', priority: 'new' };

    if (
      filing.workflowStatusId === WorkflowStatuses.New
      || filing.workflowStatusId === WorkflowStatuses.EmergencyNew
      || filing.workflowStatusId === WorkflowStatuses.NonSubstantiveNew) {
      taskPriority.color = WorkQueueColors.Blue;
      taskPriority.priority = 'new';
    } else if (
      filing.workflowStatusId === WorkflowStatuses.ReadyForPublicHearing
      || filing.workflowStatusId === WorkflowStatuses.PublicHearingPending) {
      taskPriority.color = WorkQueueColors.BlueGreen;
      taskPriority.priority = 'publicHearingPending';
    } else if (
      filing.workflowStatusId === WorkflowStatuses.AGPending
      || filing.workflowStatusId === WorkflowStatuses.AGReturnedToAgency) {
      taskPriority.color = WorkQueueColors.Green;
      taskPriority.priority = 'agPending';
    } else if (
      filing.workflowStatusId === WorkflowStatuses.GPROPending
      || filing.workflowStatusId === WorkflowStatuses.EmergencyGPROPending
      || filing.workflowStatusId === WorkflowStatuses.GPROReturnedToAgency
      || filing.workflowStatusId === WorkflowStatuses.EmergencyGPROReturnedToAgency) {
      taskPriority.color = WorkQueueColors.Yellow;
      taskPriority.priority = 'gproPending';
    } else if (filing.workflowStatusId === WorkflowStatuses.SOSPending) {
      taskPriority.color = WorkQueueColors.Orange;
      taskPriority.priority = 'sosPending';
    } else if (filing.workflowStatusId === WorkflowStatuses.ReadyForPromulgation) {
      taskPriority.color = WorkQueueColors.Red;
      taskPriority.priority = 'readyForPromulgation';
    }

    return taskPriority;
  }

  private getEffectiveOn(histories: any, workflowId: any) {
    switch (workflowId) {
      case 1: // Standard
        return histories.find((x: any) => x.workflowStatusId === 2)?.createdOn;
      case 2: // Emergency
        return histories.find((x: any) => x.workflowStatusId === 26)?.createdOn;
      case 3: // Non-Substantive
        return histories.find((x: any) => x.workflowStatusId === 6)?.createdOn;
      default:
        return null;
    }
  }

  public createCards(filings: Filing[], histories: any) {
    let priority: any;
    let cards: TaskBoardCard[] = [];
    if (filings) {
      for (let filing of filings) {
        priority = this.getPriority(filing);
        let filingHistories = histories.filter((x: any) => x.filingId === filing.id);

        let card: any = {
          id: filing.id!,
          title: filing.filingName,
          description: filing.filingName,
          filingDetail: filing.filingDetail,
          filedOn: filing.createdOn,
          createdBy: filing.createdBy,
          hearingDate: filing.hearingDate,
          docketNumberDto: filing.docketNumberDto,
          status: priority.priority,
          priority: priority,
          titleId: filing.titleId,
          chapterId: filing.chapterId,
          filingFormName: filing.filingFormName?.match(/[A-Z][a-z]+|[0-9]+/g)!.join(' '),
          titleNumber: filing.titleNumber,
          titleName: filing.titleName,
          agencyName: filing.agencyName,
          associatedChapters: filing.associatedChapters,
          effectiveOn: filingHistories.length > 0 ? this.getEffectiveOn(filingHistories, filing.workflowId) : null,
        };
        cards.push(card);
      }
    }
    return cards;
  }
}

export default CardHelper;
